<template>
    <b-modal
        v-if="group_form !== null"
        size="lg"
        v-model="modalShow"
        :title="`フォーム編集`"
        ok-title="編集"
        ok-variant="yokumiru-orange"
        cancel-title="キャンセル"
        cancel-variant="yokumiru-gray"
        :ok-disabled="inProgress"
        :cancel-disabled="inProgress"
        @ok="handleOk"
        @cancel="close"
        @hidden="close">
        <form @submit.stop.prevent="editGroupForm">
            <div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label for="form-url">フォームURL</label>
                            <input
                                v-model="group_form.form_url"
                                type="text"
                                class="form-control m-input"
                                disabled>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label class="service-model is-required-ja">
                                サービスモデル
                            </label>
                            <select 
                                v-model="group_form.plan_id"
                                disabled
                                class="form-control">
                                <template>
                                    <option :value="null">サービスモデルを選択</option>
                                    <option
                                        v-for="plan in filteredPlans"
                                        :value="plan.id">
                                        {{ plan.name }}
                                    </option>
                                </template>
                            </select>
                            <div
                                v-if="errors.plan_id"
                                class="invalid-feedback d-block">
                                {{ errors.plan_id[0] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="form-group m-form__group">
                            <label for="period-start">出国日</label>
                            <input
                                v-model="group_form.period_start"
                                type="date"
                                class="form-control"
                                disabled>
                           <div
                                v-if="errors.period_start"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.period_start[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="form-group m-form__group">
                            <label for="period-end">帰国日</label>
                            <input
                                v-model="group_form.period_end"
                                type="date"
                                class="form-control"
                                disabled>
                            <div
                                v-if="errors.period_end"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.period_end[0] }}
                            </div>
                        </div>
                        <div v-if="canEditPeriod" class="period-length text-muted">
                            渡航日数：{{ periodLength > 0 ? periodLength : '-' }}日
                        </div>
                    </div>
                </div>

                
                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label for="form-url">利用アカウント発行メールに表記する団体名</label>
                            <input
                                v-model="group_form.group_name"
                                type="text"
                                class="form-control m-input"
                                placeholder="団体名を記入してください"
                                >
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label class="service-model">
                                所属法人
                            </label>
                            <select
                            v-model="group_form.child_group_id"
                            id="status"
                            class="form-control inputSearchPlanId"
                            disabled>
                            <option :value="null">所属{{ childGroupName }}を選択</option>
                            <option
                                v-for="group in group.child_groups"
                                :value="group.id">
                                {{ group.name }}
                            </option>
                        </select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label class="service-model">
                                法人担当者設定
                            </label>
                            <div class="m-radio-inline flex-radio">
                                <label class="m-radio mr-2 pt-1">
                                    <input v-model="group_form.is_authorizer" type="radio" :value="1" name="is_authorizer" disabled> 
                                    <span>このフォームからの登録者を法人担当者に設定する</span>
                                </label>
                                <label class="m-radio mr-2 pt-1">
                                    <input v-model="group_form.is_authorizer" type="radio" :value="0" name="is_authorizer" disabled>
                                    <span>このフォームからの登録者を法人担当者に設定しない</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label class="service-model">
                                フォームの状態
                            </label>
                            <div class="m-radio-inline">
                                <label class="m-radio mr-2 pt-1">
                                    <input 
                                    v-model="group_form.is_enabled"
                                    type="radio"
                                    :value='1'
                                    name="is_enabled"
                                    >
                                    <span>有効</span>
                                </label>
                                <label class="m-radio mr-2 pt-1">
                                    <input 
                                    v-model="group_form.is_enabled"
                                    type="radio"
                                    :value='0'
                                    name="is_enabled"
                                    >
                                    <span>無効</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div
            slot="modal-footer"
            class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
            <button
                class="btn btn-yokumiru-orange float-right"
                :disabled="inProgress"
                @click="handleOk">
                更新
            </button>
        </div>
    </b-modal>
</template>

<script>
import constants from '../../../../constants'
import moment from 'moment-timezone'
import YokumiruHelper from '../../../../YokumiruHelper'
import VueTagsInput from '@johmun/vue-tags-input'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        VueTagsInput,
        quillEditor,
    },

    props: {
        groupType: {
            type: Number,
            required: true,
        },
        childGroupName: {
            type: String,
            default: '法人',
        },
        group: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            plans: [],
            group_form: null,
            group_form_token: null,
            errors: {},
            periodLength: 0,
        }
    },

    computed: {
        groupTypeName: function () {
            return this.helper.groupTypeName(this.groupType)
        },

        isOrganization: function () {
            return this.groupType === constants.groupType.organization
        },

        isCompany: function () {
            return this.groupType === constants.groupType.company
        },

        freePlan: function () {
            return this.plans.find((plan) => plan.key === constants.plans.free)
        },

        freePlanId: function () {
            return this.freePlan ? this.freePlan.id : null
        },

        filteredPlans: function () {
            return this.plans.filter((plan) => plan.id !== this.freePlanId)
        },

        canEditPeriod: function() {
            if (!this.group_form.plan_id) {
                return false
            }
            const plan = this.plans.find((plan) => {
                return plan.id === this.group_form.plan_id
            })
            return !this.helper.isCyclePlan(plan)
        }
    },

    created: function () {
        this.fetchPlans()
        this.initGroupForm()

        bus.$on('open-modal-admin-edit-form', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-admin-edit-form')
    },

    watch: {
        groupPlanIds: function (ids) {
            if (Array.isArray(ids) && !ids.includes(null)) {
                this.groupPlanIds.push(null)
            }
        },
    },

    methods: {
        /**
         * プラン一覧取得
         */
        fetchPlans: function () {
            axios.get(constants.admin.plans.endpoint.base)
                .then(({data}) => {
                    this.plans = data.data
                })
        },

        /**
         * グループの初期化
         */
        initGroupForm: function () {
            this.groupPlanIds = [this.freePlanId]

            this.group_form = {
                group_id: this.group.id,
                token: null,
                plan_id: null,
                period_start: null,
                period_end: null,
                group_name: "",
                child_group_id: null,
                is_authorizer: 0,
                is_enabled: 0,
                created_at: "",
                updated_at: "",
                group: [],
                child_group: [],
                plan: [],
                form_url: "",
            }
        },

        /**
         * 利用プランの選択プルダウンを追加
         */
        onClickAddSelectPlan: function () {
            this.groupPlanIds.push(null)
        },

        /**
         * モーダル表示
         */
        open: function (group_form_token) {
            this.group_form_token = group_form_token
            this.group_form = {
                group_id: group_form_token.group_id,
                token: group_form_token.token,
                plan_id: group_form_token.plan_id,
                period_start: group_form_token.period_start ? moment(group_form_token.period_start).format('YYYY-MM-DD') : null,
                period_end: group_form_token.period_end ? moment(group_form_token.period_end).format('YYYY-MM-DD') : null,
                group_name: group_form_token.group_name,
                child_group_id: group_form_token.child_group_id,
                is_authorizer: group_form_token.is_authorizer,
                is_enabled: group_form_token.is_enabled,
                form_url: group_form_token.form_url,
            }
            this.subscriptionPeriod(this.group_form.period_start, this.group_form.period_end)
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.modalShow = false
            this.errors = {}
        },

        /**
         * 追加ボタン押下時
         *
         * @param {object} e
         */
        handleOk: function (e) {
            e.preventDefault()
            this.editGroupForm()
        },

        /**
         * 利用アカウント発行フォーム更新
         */
        editGroupForm: async function () {
            if (this.inProgress) return
            if (!this.group_form) return
            if (!this.group_form_token) return

            this.inProgress = true

            const endpoint = constants.admin.groups.endpoint.base
            
            const params = {
                plan_id: this.group_form.plan_id,
                period_start: this.group_form.period_start,
                period_end: this.group_form.period_end,
                group_id: this.group_form.group_id,
                group_name: this.group_form.group_name,
                is_enabled: this.group_form.is_enabled,
            }

            await axios.put(`${endpoint}/${this.group.id}/group_form_tokens/${this.group_form_token.id}`, params)
                .then(() => {
                    bus.$emit('alert-success', `フォームを更新しました。`)
                    bus.$emit('fetch-group-form-tokens')
                    this.errors = {}
                    this.close()
                })
                .catch(({response}) => {
                    if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                        bus.$emit('alert-danger')
                        this.errors = response.data.errors
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },

        subscriptionPeriod(ps, pe) {
            if (!ps || !pe) return

            const length = moment(pe).diff(moment(ps), 'days')

            if (length >= 0) {
                this.periodLength = length + 1
            }
            else {
                this.periodLength = 0
            }
        },
    },
}
</script>

<style scoped lang="scss">
.incDecButton {
    width: 37px;
    height: 37px;
    margin-left: 10px;
    line-height: 37px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background: #4E7DAB;
    border-radius: 5px;
    cursor: pointer;

    &.incDecButtonRemove {
        color: #818181;
        background: #e8e8e8;
    }
}

.flex-radio{
    display: flex;
    flex-direction: column;
}

.period-length {
    font-size: 13px;
    text-align: end;
}
</style>
